import { QueueEmptyNode } from '../types';
import { PropsWithChildren } from 'react';

type NodeEmptyProps = {
  node: QueueEmptyNode;
};

export const NodeEmpty = ({ children }: PropsWithChildren<NodeEmptyProps>) => children;

NodeEmpty.displayName = 'NodeEmpty';
